module.exports = __webpack_public_path__ + "static/img/1-3.c0c18da2.jpg";